import { render, staticRenderFns } from "./YearTab.vue?vue&type=template&id=6b2e2e4a&scoped=true"
import script from "./YearTab.vue?vue&type=script&lang=js"
export * from "./YearTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e2e4a",
  null
  
)

export default component.exports